import androidx.compose.runtime.*
import frontend.lib.displayCurrencyCode
import net.sergeych.ugdx.GuestAPI
import net.sergeych.ugdx.shared.Currency
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class CurrencySelectAttrsBuilder {
    var onChange: (value: Currency?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<Currency> by mutableStateOf(emptyList())
    var isDisabled = false
    var isOptionsLoaded = false
    var isCondensed = false
    var filter: (value: Currency) -> Boolean = { true }

    fun onChange(handler: (value: Currency?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun disabled() { isDisabled = true }
    fun options(list: List<Currency>) {
        options = list
        isOptionsLoaded = true
    }

    fun filter(handler: (currency: Currency) -> Boolean) {
        filter = handler
    }

    fun condensed() { isCondensed = true }
}

@Composable
fun CurrencySelect(
    id: String,
    selected: Currency?,
    attrs: CurrencySelectAttrsBuilder.() -> Unit = {}
) {
    val scope = rememberCoroutineScope()
    val builder = CurrencySelectAttrsBuilder()
    attrs.invoke(builder)

    if (!builder.isOptionsLoaded) {
        println("Load currencies for select")
        scope.launch {
            builder.options = GuestAPI().getCurrencies().filter(builder.filter)
        }
        builder.isOptionsLoaded = true
    }

    Div() {
        if (!builder.isCondensed) Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10",
                if (builder.isCondensed) "py-1" else "py-2",
                "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val code = it.value
                val currency = builder.options.find { it.code == code }
                builder.onChange(currency)
            }
        }) {
            builder.options.forEach {
                val option = it

                Option(option.code, attrs = {
                    if (selected?.code == option.code) selected()
                }) { Text("${displayCurrencyCode(option)}: ${option.name}") }
            }
        }
    }
}
